import { render, staticRenderFns } from "./PayoutList.vue?vue&type=template&id=18b977a4&scoped=true&"
import script from "./PayoutList.vue?vue&type=script&lang=js&"
export * from "./PayoutList.vue?vue&type=script&lang=js&"
import style0 from "./PayoutList.vue?vue&type=style&index=0&id=18b977a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18b977a4",
  null
  
)

export default component.exports